// extracted by mini-css-extract-plugin
export default {"headerContainer":"EditNonHRMSEmployee_headerContainer__7ZEFI","headerText":"EditNonHRMSEmployee_headerText__cSF1B","text":"EditNonHRMSEmployee_text__wgTej"};